import Overview from './components/overview/Overview.vue';
import Customers from './components/customers/Customers.vue';
import Customer from './components/customers/Customer.vue';
import Products from './components/products/Products.vue';
import Product from './components/products/Product.vue';
import Cases from './components/cases/Cases.vue';
import Case from './components/cases/Case.vue';
import CreateCase from './components/cases/CreateCase.vue';
import Invoices from './components/invoices/Invoices.vue';
import Invoice from './components/invoices/Invoice.vue';
import CreateInvoice from './components/invoices/CreateInvoice.vue';


import AppsOverview from './components/apps/AppOverview.vue';
import AppVochers from './components/apps/Vochers.vue';
import AppMcSearch from './components/apps/MinecraftSearch.vue';

const routes = [
    { path: '/', component: Overview },
    { path: '/customers', component: Customers },
    { path: '/customers/:uniqueid', component: Customer },
    { path: '/customers', component: Customers },
    { path: '/products/:productid', component: Product },
    { path: '/products', component: Products },
    { path: '/cases', component: Cases },
    { path: '/cases/create/:uniqueid', component: CreateCase },
    { path: '/cases/:caseid', component: Case },
    { path: '/invoices', component: Invoices },
    { path: '/invoices/create/:uniqueid', component: CreateInvoice },
    { path: '/invoices/:invoiceid', component: Invoice },
    { path: '/apps', component: AppsOverview },
    { path: '/apps/vochers', component: AppVochers },
    { path: '/apps/mcsearch', component: AppMcSearch },
];

export default routes;